<template>
    <div class="linksUser" v-if="this.ambassadorLimitTokens >= 0">
        <div class="container-fluid">
            <div class="card center card--flex">
                <div class="div__cont" v-if="(this.isAmbassador || this.isAmbassadorPlus || this.isFranchiseeBA) && this.hasTokenAvailable">
                    <div class="div__btns" v-if="!hideButtonDashboard">
                        <a
                            v-if="!this.isAmbassador"
                            class="btn__link"
                            @click="this.updateStep"
                        >{{translation.panel_bussiness}}</a>
                    </div>
                    <!-- <div
                        class="input--out"
                        v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']"
                    >
                        <span>{{translation.link}}</span>
                        <input
                            v-if="!step4"
                            type="text"
                            :value="this.generalLinkShare"
                            id="general-share-link"
                            class="general-input"
                        />
                        <input
                            v-if="step4"
                            type="text"
                            :value="this.linkFunnel"
                            id="general-share-link"
                            class="general-input"
                        />
                        <div data-clipboard-target="#general-share-link" class="copy">
                            <i class="fa fa-cut"></i>
                            <a>{{translation.copy_link}}</a>
                        </div>
                    </div> -->
                    <div
                        class="ambassadors__links"
                    >
                        <div class="input--out col-sm-6 col-lg-4"
                            v-for="(linkAmbassador, index) in allLinksAmbassador"
                            :id="['js-ambassador-div-group-' + index]"
                            :key="index"
                        >
                            <span>{{translation.link_ambassador}}:</span>
                            <fs5-input-copy :view="['',linkAmbassador,translation.copied]" :styleType="'link-affiliate'"/>
                        </div>
                        <div class="col-sm-6 col-lg-4 box-select-currency">
                            <span>{{translation.ad_config_moeda}}:</span>
                            <select
                                class="select__language"
                                @change="handleLinkAmbassador"
                                v-model="currencyLinkAmbassador"
                            >
                                <option value="BRL">{{translation.brl}}</option>
                                <option value="USD">{{translation.usd}}</option>
                                <option value="EUR">{{translation.eur}}</option>
                            </select>

                            <!-- <button  class="select__language" @click="amabassadorPixels()" v-text="translation.pixels"></button> -->
                        </div>
                        <div class="box-used-tokens">
                            <div v-if="ambassadorLimitTokens == 0">
                                <span>{{translation.unlimited_token}}</span>
                            </div>
                            <div v-else>
                                <span>{{translation.used_token}}</span>
                                <span>{{ambassadorUsedTokens}}/{{ambassadorLimitTokens}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div
                        class="input--out"
                        v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']"
                        v-if="(this.isAmbassador || this.isAmbassadorPlus) && this.isBr && this.langBr == 'br'"
                    >
                        <span>{{translation.link_ambassador_webinar}}</span>
                        <input
                            type="text"
                            :value="this.linkWebinar"
                            id="webinar-ambassador-share-link"
                            class="general-input"
                        />
                        <div data-clipboard-target="#webinar-ambassador-share-link" class="copy">
                            <i class="fa fa-cut"></i>
                            <a>{{translation.copy_link}}</a>
                        </div>
                    </div> -->
                </div>
                <div v-if="(this.isAmbassador || this.isAmbassadorPlus || this.isFranchiseeBA) && !this.hasTokenAvailable">
                    <span class="limit__token__reached">{{ translation.ambassador_tokens_limit_reached }}</span>
                </div>
            </div>
        </div>

        <pixel-events-settings-modal v-if="(this.isAmbassador || this.isAmbassadorPlus || this.isFranchiseeBA)"  :event="pixelEvent"></pixel-events-settings-modal>

        <div class="container-fluid coupon" v-if="this.showCoupon">
            <div class="card center card--flex">
                <div class="div__cont">
                    <div
                        class="ambassadors__links"
                    >
                        <div class="input--out col-sm-12">
                            <div style="display: flex;">
                                <span>{{translation.cupom_ambassador_affiliate}}</span>
                                <span class="helper__tooltip">
                                    <span class="helper__tooltip--text">
                                        {{translation.cupom_ambassador_affiliate_helper}}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="input--out col-sm-12">
                            <div class="b-b-i">
                                <input
                                    type="text"
                                    :value="'https://checkout.builderall.com/payment/funil-clube-brl-149?coupon=METADE&aid=' + props.dados_usuario_office.id"
                                    id="general-ambassador-share-link-coupon"
                                    class="general-input-coupon"
                                />
                                <div
                                    class="copy ic-copy"
                                    data-clipboard-target="#general-ambassador-share-link-coupon"
                                    data-labelCopy="copied"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "links-user",
    props: ["props", "funnel"],
    components: {},
    data() {
        return {
            generalLinkShare: null,
            isAmbassador: null,
            isAmbassadorPlus: null,
            isFranchiseeBA: null,
            allLinksAmbassador: [],
            ambassadorUsedTokens: null,
            ambassadorLimitTokens: null,
            hasTokenAvailable: false,
            ambassadorUsedTokens: null,
            currencyLinkAmbassador: "BRL",
            translation: this.$parent.view.translation.linksUser,
            urls: this.$parent.view.urls,
            hideButtonDashboard: false,
            step4: false,
            linkFunnel: null,
            isBr: this.$parent.view.IS_BR,
            langBr: this.$parent.view.lang,
            linkWebinar: null,
            pixelEvent: '',
            showCoupon: false
        };
    },
    methods: {
        handleLinkAmbassador() {
            if (this.currencyLinkAmbassador == "BRL")
                this.showAndHideAmbassadorsLinks("brl");
            if (this.currencyLinkAmbassador == "USD")
                this.showAndHideAmbassadorsLinks("usd");
            if (this.currencyLinkAmbassador == "EUR")
                this.showAndHideAmbassadorsLinks("eur");
        },
        showAndHideAmbassadorsLinks(linkToShow) {
            let brl = document.getElementById("js-ambassador-div-group-BRL");
            let usd = document.getElementById("js-ambassador-div-group-USD");
            let eur = document.getElementById("js-ambassador-div-group-EUR");
            brl.style.display = "none";
            usd.style.display = "none";
            eur.style.display = "none";
            if (linkToShow == "brl") brl.style.display = "flex";
            if (linkToShow == "usd") usd.style.display = "flex";
            if (linkToShow == "eur") eur.style.display = "flex";
        },
        amabassadorPixels(){
            this.pixelEvent = 'ambassador-token';
            $('#modalPixelSettings').modal('show');
        },
        // updateStep() {
        //     this.$parent.nextStep();
        // }
    },
    created() {

        // if (this.isStep4) {
        //     this.step4 = this.isStep4;
        //     this.linkFunnel = `${this.funnel}#aid=${this.props.dados_usuario_office.id}`;
        // }
        // https://office.builderall.com/us/franchise/share/186853?p1=rd&p2=https%3A%2F%2Fbr.erickambassadors.com%2F/
        this.linkWebinar = `https://office.builderall.com/br/franchise/share/${this.props.dados_usuario_office.id}/?p1=rd&p2=https%3A%2F%2Fbr.erickambassadors.com%2F/`;
    },
    mounted() {
        console.log('====================================');
        console.log(this.props.data.show_coupon_500OFF);
        console.log('====================================');
        //coupon
        this.showCoupon = this.props.data.show_coupon_500OFF;

        //ambassador info
        this.hasTokenAvailable = this.props.has_tokens_available;
        this.ambassadorUsedTokens = this.props.ambassador_used_tokens;
        this.ambassadorLimitTokens = this.props.ambassador_limit_tokens;
        this.generalLinkShare = this.props.link_user
            ? this.props.link_user
            : false;
        this.isAmbassador = this.props.IS_AMBASSADOR
            ? this.props.IS_AMBASSADOR
            : false;
        this.isAmbassadorPlus = this.props.IS_AMBASSADOR_PLUS
            ? this.props.IS_AMBASSADOR_PLUS
            : false;
        this.isFranchiseeBA = this.props.IS_FRANCHISEE_BA
            ? this.props.IS_FRANCHISEE_BA
            : false;

        this.allLinksAmbassador = this.props.url_ambassador;
        // removido links de embaixadores em usd e eur
        // delete this.allLinksAmbassador['USD'];
        // delete this.allLinksAmbassador['EUR'];

        // console.log(this.allLinksAmbassador);

        this.hideButtonDashboard =
            document.location.pathname == this.urls.rota_dashboard &&
            this.$parent.stepIndex == 0;
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.linksUser {
    .div__cont {
        // max-width: 800px;
        width: 90%;
        // min-width: 314px;
    }
    .container-fluid {
        padding-right: 0;
        padding-left: 0;

        .card {
            margin-bottom: 23px;
            margin-top: 17px;
			background: #fff;
            border: 1px solid #C9E4FF;
        }
    }
    .in-line {
        display: flex;
        margin-bottom: 6px;
        width: 100%;
    }
    .div__btns {
        width: 100%;
        margin-bottom: 5px;
        .btn__link {
            align-items: center;
            justify-content: center;
            display: block;
            color: #0080FC;
            font-weight: 700;
            border-radius: 4px;
            -webkit-transition: 0.3s all;
            transition: 0.3s all;
            text-align: center;
            margin-right: 12px;
            height: 40px;
            display: flex;
            padding: 10px;
            font-size: 15px;
            align-items: center;
            cursor: pointer;
            width: 100%;
        }
    }
}
.info__token {
    span {
        color: #A5B9D5;
        font-size: 15px;
        &:first-child {
            font-weight: 700;
        }
    }
}
.ic-copy {
    width: 19px;
    height: 18px;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0id2hpdGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBkPSJNOS40NzAwMiAxNEgyLjE3ODQyQzEuMjkzNDkgMTQgMC41NzQyMTkgMTMuMjgwNyAwLjU3NDIxOSAxMi4zOTU4VjQuNTIwOEMwLjU3NDIxOSAzLjYzNTg2IDEuMjkzNDkgMi45MTY3IDIuMTc4NDIgMi45MTY3SDIuNDcwMDJDMi43MTE1MiAyLjkxNjcgMi45MDc1MiAzLjExMjcgMi45MDc1MiAzLjM1NDJDMi45MDc1MiAzLjU5NTcgMi43MTE1MiAzLjc5MTcgMi40NzAwMiAzLjc5MTdIMi4xNzg0MkMxLjc3NjQ5IDMuNzkxNyAxLjQ0OTIyIDQuMTE4ODcgMS40NDkyMiA0LjUyMDhWMTIuMzk1OEMxLjQ0OTIyIDEyLjc5NzcgMS43NzY0OSAxMy4xMjUgMi4xNzg0MiAxMy4xMjVIOS40NzAwMkM5Ljg3MTk1IDEzLjEyNSAxMC4xOTkyIDEyLjc5NzcgMTAuMTk5MiAxMi4zOTU4VjEyLjEwNDJDMTAuMTk5MiAxMS44NjI3IDEwLjM5NTIgMTEuNjY2NyAxMC42MzY3IDExLjY2NjdDMTAuODc4MiAxMS42NjY3IDExLjA3NDIgMTEuODYyNyAxMS4wNzQyIDEyLjEwNDJWMTIuMzk1OEMxMS4wNzQyIDEzLjI4MDcgMTAuMzU0OSAxNCA5LjQ3MDAyIDE0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTExLjgwMzQgMTAuNUg1LjY3ODQyQzQuNzkzNDkgMTAuNSA0LjA3NDIyIDkuNzgwNzMgNC4wNzQyMiA4Ljg5NThWMS42MDQyQzQuMDc0MjIgMC43MTkyNjkgNC43OTM0OSAwIDUuNjc4NDIgMEgxMS44MDM0QzEyLjY4ODQgMCAxMy40MDc1IDAuNzE5MjY5IDEzLjQwNzUgMS42MDQyVjguODk1OEMxMy40MDc1IDkuNzgwNzMgMTIuNjg4NCAxMC41IDExLjgwMzQgMTAuNVpNNS42Nzg0MiAwLjg3NUM1LjI3NjQ5IDAuODc1IDQuOTQ5MjIgMS4yMDIyNyA0Ljk0OTIyIDEuNjA0MlY4Ljg5NThDNC45NDkyMiA5LjI5NzczIDUuMjc2NDkgOS42MjUgNS42Nzg0MiA5LjYyNUgxMS44MDM0QzEyLjIwNTQgOS42MjUgMTIuNTMyNSA5LjI5NzczIDEyLjUzMjUgOC44OTU4VjEuNjA0MkMxMi41MzI1IDEuMjAyMjcgMTIuMjA1NCAwLjg3NSAxMS44MDM0IDAuODc1SDUuNjc4NDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==);
    display: block;
}
span {
	color: #A5B9D5;
	font-size: 15px;
}
.card--flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .input--out {
        border-radius: 8px;
        display: flex;
        align-items: center;
        color: #0080FC;
        height: 40px;
        font-size: 15px;
        padding: 0 5px 0 5px;
        margin-bottom: 5px;
        position: relative;
        justify-content: space-evenly;
        span {
            font-weight: 700;
            font-size: 15px;
			flex: 1;
            white-space: nowrap;
        }
        .general-input {
            width: 90%;
    		font-size: .8rem;
        }
        .general-input-coupon {
            background: #0280f9;
            width: 90%;
            font-size: .8rem;
        }
		.b-b-i {
			display: flex;
			border-bottom: 1px solid #0080FC;
			padding-bottom: .3rem;
			justify-content: space-between;
			flex: 4;
		}
        input {
            border: 0;
            // margin: 0 0.8rem;
            padding: 0;
			background: transparent;
            &:focus {
                padding: 0;
                outline: none;
            }
        }
        a {
            margin-left: 3px;
            color: #0080FC;
            font-weight: 100;
        }
    }
    .ambassadors__links {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: space-between;
        width: 100%;
        .box-select-currency{
            align-items: center;
            gap: 1rem;
            display: flex;
            justify-content: center;
        }
        .select__language {
            border: 1px solid #0080FC;
			background: transparent;
            padding: 0 1rem;
            border-radius: 5px;
            color: #0080FC;
            font-weight: 700;
            font-size: 15px;
            text-transform: uppercase;
            min-height: 38px;
            transition: .5s;
            cursor: pointer;
            &:focus {
                overflow: auto;
                outline: none;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }
        }
    }
    .limit__token__reached {
        font-weight: 700;
        font-size: 15px;
        color: #0080FC;
    }
    // #js-ambassador-div-group-BRL,
    #js-ambassador-div-group-USD,
    #js-ambassador-div-group-EUR {
        display: none;
    }
}
.helper__tooltip::after {
    top: -1px;
}
@media (max-width: 1150px) {
    .linksUser {
        margin: 0;
    }
    .linksUser .div__cont {
        max-width: unset;
        width: 100%;
    }
    .card--flex .input--out {
        width: 100%;
    }
}
@media (max-width: 450px) {
	.width-full-dashboard {
		flex-direction: column;
	}
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/linksUser.vue